import { clsx } from 'clsx'
import { useEffect, useState } from 'react'
import * as styles from './index.css'
import { SpoilerContext } from './SpoilerContext'

export interface SpoilerContainerProps {
  state: 'fold' | 'expand'
  className?: string
  children: React.ReactNode
  onChange?: (newState: 'fold' | 'expand') => void
}

export const SpoilerContainer = (props: SpoilerContainerProps) => {
  const [state, setState] = useState(props.state)

  const isExpanded = state === 'expand'

  const toggle = () => {
    const nextState = isExpanded ? 'fold' : 'expand'
    setState(nextState)
    if (props.onChange) {
      props.onChange(nextState)
    }
  }

  useEffect(() => {
    setState(props.state)
  }, [props.state])

  return (
    <SpoilerContext.Provider value={{ state, isExpanded, toggle }}>
      <div className={clsx(styles.container, props.className)}>
        {props.children}
      </div>
    </SpoilerContext.Provider>
  )
}
